import { render } from "./ReportsListingSettingsHeader.vue?vue&type=template&id=842c2c64"
import script from "./ReportsListingSettingsHeader.vue?vue&type=script&lang=js"
export * from "./ReportsListingSettingsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__